import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { AppState, selectConfiguration, selectMicrositeSessionsIsLoggedIn, track } from '@cbcore/NGRX/core.state';
import { Store } from '@ngrx/store';
import { SlicePipe } from '@angular/common';
import { ImagesLazyLoadDirective } from '../../../helpers/directives/images-lazy-load';
import { Config } from "@cbcore/services/config/config.service";
import { combineLatest, map, shareReplay } from 'rxjs';
import { result, find } from 'lodash-es';
import { ManagersScope } from '@cbcore/NGRX/manager/manager.model';
import { selectManagersState } from '@cbcore/NGRX/manager/manager.selectors';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';

@Component({
    selector: 'widget-top-captains-list',
    templateUrl: './top-captains-list.html',
    imports: [PipesModule,
    TranslocoModule,
    CommonModule,
    
        ImagesLazyLoadDirective
    ],
    providers: [
        SlicePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class WidgetTopCaptainsListComponent {
  @Input() data?: {
    total_items: number;
    items: ManagersScope.Manager[];
  };

  public imagesUrl: string;
  public fallbackMangerImage: string;

  public state$ = combineLatest([
    this.store.select(selectConfiguration),
    this.store.select(selectManagersState),
    this.store.select(selectMicrositeSessionsIsLoggedIn)
  ]).pipe(
    map(([config, managers, isLoggedIn]) => ({
      displayState: config.displayState,
      fxrates: config.fxRates,
      sportCategoryId: managers.leaderboardWidgetParams?.sport_category?.id,
      isLoggedIn
    })),
    shareReplay(1)
  );

  constructor(
    private _router: Router,
    private _config: Config,
    private store: Store<AppState>
  ) {
    this.imagesUrl = this._config.CONFIG.imagesUrl;
    this.fallbackMangerImage = this.imagesUrl + this._config.CONFIG.fallbackSyndicateProfileImage;
  }

  getSyndicateCounter(manager: ManagersScope.Manager, sportCategoryId: number): number {
    return result(
      find(manager.manager_counters, { sport_category_id: sportCategoryId }),
      'open_syndicates_count',
      0
    );
  }

  setFallbackImage(manager: ManagersScope.Manager): void {
    try {
      manager.picture_url = this.fallbackMangerImage;
    } catch(e: any) { /* empty */ }
  }

  openLink(url: string[]): void {
    this.trackBannerClicks();
    this._router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    }
    this._router.navigate(url);
  }

  trackBannerClicks(): void {
    const trackingObject = {
      'event': 'micrositeEvent',
      'eventCategory': 'RHW_Banner',
      'eventAction': 'Click',
      'eventLabel': this.state$.pipe(
        map(state => state.displayState.view)
      )
    }

    this.store.dispatch(track({event: trackingObject}));
  }

  trackByManager(index: number, manager: ManagersScope.Manager): number {
    return manager.id;
  }
}
